<div class="closeSplashScreen">
  <div class="cover">
    <span>{{ screenText }}</span>
    <div class="btnContainer">
      <button cignaButton="primary" class="btnEndChat" (click)="endChat()">
        End Chat
      </button>
      <button cignaButton="secondary" class="btnKeepChat" (click)="keepChat()">
        Keep Chatting
      </button>
    </div>
  </div>
</div>
